import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getUri, selectSsoError } from '../../store/sso';
import './LoginSSO.css';

function LoginSSO({ checkAuthorization, showHeader }) {
  const { ssoId } = useParams();
  const [organizationName, setOrganizationName] = useState(ssoId ?? '');
  const dispatch = useDispatch();
  const error = useSelector(selectSsoError);

  useEffect(() => {
    showHeader(false);
    checkAuthorization('/login-sso');
    return () => showHeader(true);
  }, [showHeader, checkAuthorization]);

  useEffect(() => {
    if (ssoId) {
      dispatch(getUri(ssoId));
    }
  }, [ssoId, dispatch]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      // test organization name on staging: MorganStanleyStaging
      dispatch(getUri(organizationName.trim()));
    },
    [organizationName, dispatch]
  );

  const handleIntercom = useCallback((e) => {
    e.preventDefault();
    if (window?.Intercom) {
      window.Intercom('show');
    }
  }, []);

  const handleChangeOrganizationName = useCallback((e) => setOrganizationName(e.target.value), []);

  return (
    <div className="login-content login-sso content-container">
      <form onSubmit={handleSubmit}>
        <div>
          <img className="login-logo" src="/sl_logo_name_v2_light.png" alt="Socialive Logo" />
        </div>
        <h1 className="login-header">Sign in with SSO</h1>
        <fieldset>
          <label className="text-input-label" htmlFor="organizationName">
            ENTER YOUR ORGANIZATION NAME
            <input id="organizationName" type="text" onChange={handleChangeOrganizationName} value={organizationName} />
          </label>
          <div className="submit-container">
            <button disabled={!organizationName} type="submit" id="submitButton">
              <span className="submit-text">Continue</span>
            </button>
          </div>
        </fieldset>
        {error && (
          <div className="error-block">
            <span className="error">Please check your organization name or sign in with your email and password</span>
          </div>
        )}
        <p>
          Don&apos;t know your organization name?&nbsp;
          <button className="contact-us-btn anchor" type="button" onClick={handleIntercom}>
            Contact us
          </button>
        </p>
        <p>
          Don&apos;t use SSO?&nbsp;<Link to="/login">Sign in with password</Link>
        </p>
      </form>
    </div>
  );
}

LoginSSO.propTypes = {
  checkAuthorization: PropTypes.func.isRequired,
  showHeader: PropTypes.func.isRequired,
};

export default LoginSSO;
